import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { chackBillPaymentStatus } from '../../services/billing';
import { Loader } from 'lucide-react';
import Spacing from '../Spacing';

export default function BillingPaymentTracker() {
  const { shortener_slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    checkPaymentSlug();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkPaymentSlug = async () => {
    try {
      const response = await chackBillPaymentStatus({shortener_slug});
      if(response){
        if(response?.data?.url){
          window.location.href = response?.data?.url;
        } else {
          navigate("/");
        }
      }
    } catch (error) { }
  }

  return (
    <>
      <div style={{ height: '100vh' }} className='relative'>
        <div className="absolute top-0 left-0 w-full" style={{ height: '100%', zIndex: 3 }}>
          <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'rgb(255 255 255 / 63%)' }}>
            <div>
              <span className="docpro_loading" style={{ position: 'inherit' }}>
                <Loader width={46} height={46} style={{ color: 'var(--ternary)' }} />
              </span>
              <Spacing lg="20" sm="20" />
              <p style={{ color: 'var(--ternary)' }}>Loading ...</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
